<ng-container *ngIf="product">
  <div class="card shadow-sm animate__animated animate__fadeIn">
    <!-- Product image-->
    <div
      class="card-img-top"
      [ngStyle]="{
        'background-image': 'url(' + product.image + ' )'
      }"
      routerLink="/pdp/{{ product.id }}"
    ></div>
    <!-- Product details-->
    <div class="card-body p-2">
      <div class="text-center">
        <!-- Product name-->
        <h5 class="fw-bolder">
          {{ product.title | slice: 0:19
          }}<span *ngIf="product.title.length >= 19">...</span>
        </h5>
        <!-- Product price-->
        {{ product.price | currency }}
      </div>
    </div>
    <!-- Product actions-->
    <div class="card-footer p-4 pt-0 border-top-0 bg-transparent">
      <div class="text-center btn-container">
        <input
          type="number"
          class="form-control text-center"
          [(ngModel)]="quantity"
        />
        <button class="btn btn-outline-dark mt-auto" (click)="addToCart()">
          Add to cart
        </button>
      </div>
    </div>
  </div>
</ng-container>
